export const languageOptions = [
  { code: "en", label: "English", short: "EN" },
  { code: "pt", label: "Português", short: "PT" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
  { code: "hi", label: "हिन्दी", short: "HI" },
  { code: "zh", label: "中文", short: "ZH" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "id", label: "Bahasa Indonesia", short: "ID" },
  { code: "ja", label: "日本語", short: "JA" },
  { code: "ur", label: "اردو", short: "UR", dir: "rtl" },
];
